const STORAGE_KEY_PREFIX = 'onboarding_dismissed_';

export const isOnboardingDismissed = (workspaceId, userId) => {
  if (!workspaceId || !userId) return false;

  const key = `${STORAGE_KEY_PREFIX}${workspaceId}_${userId}`;
  const value = localStorage.getItem(key);

  if (!value) return false;

  try {
    const parsed = JSON.parse(value);
    return parsed.dismissed === true;
  } catch (error) {
    return false;
  }
};

export const dismissOnboarding = (workspaceId, userId) => {
  if (!workspaceId || !userId) return;

  const key = `${STORAGE_KEY_PREFIX}${workspaceId}_${userId}`;
  const data = {
    dismissed: true,
    timestamp: Date.now(),
  };

  localStorage.setItem(key, JSON.stringify(data));
};

export const clearOnboardingDismiss = (workspaceId, userId) => {
  if (!workspaceId || !userId) return;

  const key = `${STORAGE_KEY_PREFIX}${workspaceId}_${userId}`;
  localStorage.removeItem(key);
};
